/** *******************************************************************************************************************
 * Copyright (c) 2020 - Fundação CERTI
 * All rights reserved.
 ******************************************************************************************************************* */

import React, { Component } from 'react';
import './App.css';
import * as firebase from 'firebase/app';
import 'firebase/auth';
import { Provider } from 'react-redux';
import { createStore } from 'redux';
import withFirebaseAuth from 'react-with-firebase-auth';
import { ThemeProvider } from '@material-ui/core';
import { firebaseImpl } from './utils/firebaseConfig';

import theme from './styles/global';
import Routes from './Routes';
import reducer from './core/redux/auth';

const store = createStore(reducer);
class App extends Component {
  render() {
    return (
      <ThemeProvider theme={theme}>
        <Provider store={store}>
          <Routes {...this.props} />
        </Provider>
      </ThemeProvider>
    );
  }
}

const firebaseAppAuth = firebaseImpl.auth();
const providers = {
  googleProvider: new firebase.auth.GoogleAuthProvider(),
};

export default withFirebaseAuth({
  providers,
  firebaseAppAuth,
})(App);
